export default "__VITE_ASSET__Cr88_gug__"